import * as React from "react"
import format from "date-fns/format"
import { Log } from "@modules/graphql/types"
import { ThemeCss } from "gatsby-interface"
import { keyframes } from "@emotion/core"

export type BuildSrrLogsItemProps = {
  log: Log
  nextLogInvocationId: string
  initialRecentTimestamp: number
}

export const BuildSrrLogsItem = React.memo(function BuildSrrLogsItem({
  log,
  nextLogInvocationId,
  initialRecentTimestamp,
}: BuildSrrLogsItemProps) {
  const { id, message, invocationId, timestamp } = log

  const timestampDate = timestamp ? new Date(timestamp) : undefined

  const isLastItemWithSameInvocationId = invocationId !== nextLogInvocationId

  const isDynamicallyAddedItem =
    timestampDate &&
    initialRecentTimestamp &&
    timestampDate?.getTime() > initialRecentTimestamp
  return (
    <li
      key={id}
      id={id}
      css={theme => [
        itemCss(theme),
        isLastItemWithSameInvocationId && nextInvocationCss(theme),
        isDynamicallyAddedItem && {
          animation: `${fade} 2s ease forwards`,
        },
      ]}
    >
      {timestampDate && (
        <time dateTime={timestampDate.toString()}>
          {format(timestampDate, "HH:mm:ss aa:")}
        </time>
      )}
      <p>{message}</p>
    </li>
  )
})

/* styles */

const fade = keyframes`
  from {
    background: #666;
  }
  to {
    background: transparent;
  }
`

const itemCss: ThemeCss = theme => ({
  margin: 0,
  padding: `${theme.space[1]} ${theme.space[5]}`,
  fontSize: theme.fontSizes[1],
  color: theme.colors.grey[30],

  time: {
    whiteSpace: `nowrap`,
    marginRight: theme.space[3],
    color: theme.colors.grey[40],
    fontStyle: `italic`,
  },

  "&:first-of-type": {
    paddingTop: theme.space[3],
  },

  "&:last-of-type": {
    paddingBottom: theme.space[3],
  },

  [theme.mediaQueries.desktop]: {
    display: `flex`,
    padding: `${theme.space[1]} ${theme.space[7]}`,
  },
})

const nextInvocationCss: ThemeCss = theme => ({
  marginBottom: theme.space[6],

  [theme.mediaQueries.desktop]: {
    marginBottom: theme.space[4],
  },
})
